import { ReactSession } from 'react-client-session';
import {AES, enc} from "crypto-js";
import {Suspense, useEffect, useState} from "react";
import Button from "./component-assets/Button";
import {
    checkAll,
    showModal,
    formFail,
    handleSubmitActions,
    paginateData,
    sortFunc,
    formSuccess,
    isBannerPresent,
    convertIsoToLocalDate, setDDataCampusCustom, swapModal, headerFilterFunc, searchFunc
} from "../libs";
import ApiRequester from "./ApiRequester";
import TableBody from "./component-assets/TableBody";
import TableHeaders from "./component-assets/TableHeaders";
import {Pagination} from "react-bootstrap";
import PaginationItems from "./component-assets/PaginationItems";
import Header from "./Header";
import Footer from "./Footer";
import PerPageModal from "./component-assets/PerPageModal";
import {ToastContainer} from "react-toastify";
import CampusDropDown from "./component-assets/CampusDropDown";
import Navigation from "./Navigation";

const TasksEhr = (props) => {
    let dData, bData, addHeaderData, editHeaderData, moveHeaderData, removeHeaderData, headerData2,
        paginatePage, paginateSetPage, paginateBegin, paginateEnd, paginatePMin, paginatePMax, paginateMax;

    addHeaderData = [
        {label: "First Name", key: "resident_first_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Last Name", key: "resident_last_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Nickname", key: "resident_nickname", align: "left", filtered: true},
        {label: "Area", key: "area_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "Care Level", key: "ehr_level_of_care_id", align: "left", filtered: true},
        {label: "Phone", key: "resident_phone", align: "center", type: "tel", filtered: true},
        {label: "Email", key: "resident_email", align: "left", filtered: true}
    ];
    editHeaderData = [
        {label: "First Name", key: "resident_first_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Last Name", key: "resident_last_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Nickname", key: "resident_nickname", align: "left", filtered: true},
        {label: "Area", key: "area_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "Care Level", key: "ehr_level_of_care_id", align: "left", filtered: true},
        {label: "Phone", key: "resident_phone", align: "center", type: "tel", filtered: true},
        {label: "Email", key: "resident_email", align: "left", filtered: true}
    ];
    moveHeaderData = [
        {label: "Full Name", key: "resident_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Prev Area", key: "old_area_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "New Area", key: "area_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
    ];
    removeHeaderData = [
        {label: "Full Name", key: "resident_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Area", key: "area_name", align: "center", filtered: true,
            link: {enabled: false, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}}
    ];

    headerData2 = [
        {label: "Group", key: "resident_group_name", align: "left"},
        {label: "Description", key: "resident_description", align: "left"},
    ];

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    // Main Table Variables
    const [read, setRead] = useState(true);
    const [addOrigin, setAddOrigin] = useState([]);
    const [addActive, setAddActive] = useState([]);
    const [addTableRows, setAddTableRows] = useState([]);
    const [addStoredIndex, setAddStoredIndex] = useState(0);
    const [addPage, setAddPage] = useState(1);
    const [addHeaderFilters, setAddHeaderFilters] = useState([]);
    const [addSorter, setAddSorter] = useState({
        sortColumn: "",
        sortOrder: "asc"
    });
    const [addPRules, setAddPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [activeModal, setActiveModal] = useState("");
    const [editOrigin, setEditOrigin] = useState([]);
    const [editActive, setEditActive] = useState([]);
    const [editTableRows, setEditTableRows] = useState([]);
    const [editStoredIndex, setEditStoredIndex] = useState(0);
    const [editPage, setEditPage] = useState(1);
    const [editHeaderFilters, setEditHeaderFilters] = useState([]);
    const [editSorter, setEditSorter] = useState({
        sortColumn: "",
        sortOrder: "asc"
    });
    const [editPRules, setEditPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });

    const [moveOrigin, setMoveOrigin] = useState([]);
    const [moveActive, setMoveActive] = useState([]);
    const [moveTableRows, setMoveTableRows] = useState([]);
    const [moveStoredIndex, setMoveStoredIndex] = useState(0);
    const [moveFromName, setMoveFromName] = useState("");
    const [moveToName, setMoveToName] = useState("");
    const [moveResName, setMoveResName] = useState("");
    const [movePage, setMovePage] = useState(1);
    const [moveHeaderFilters, setMoveHeaderFilters] = useState([]);
    const [moveSorter, setMoveSorter] = useState({
        sortColumn: "",
        sortOrder: "asc"
    });
    const [movePRules, setMovePRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });

    const [removeOrigin, setRemoveOrigin] = useState([]);
    const [removeActive, setRemoveActive] = useState([]);
    const [removeTableRows, setRemoveTableRows] = useState([]);
    const [removeStoredIndex, setRemoveStoredIndex] = useState(0);
    const [removeName, setRemoveName] = useState(0);
    const [removeArea, setRemoveArea] = useState("");
    const [removePage, setRemovePage] = useState(1);
    const [removeHeaderFilters, setRemoveHeaderFilters] = useState([]);
    const [removeSorter, setRemoveSorter] = useState({
        sortColumn: "",
        sortOrder: "asc"
    });
    const [removePRules, setRemovePRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    // Group picker table Variables
    const [groupData, setGroupData] = useState([]);
    const [resGroupIdList, setResGroupIdList] = useState([]);
    const [groupDataCnt, setGroupDataCnt] = useState(0);
    const [groupTableRows, setGroupTableRows] = useState([]);
    const [search2, setSearch2] = useState("");
    const [sorter2, setSorter2] = useState({
        sortColumn: "resident_group_name",
        sortOrder: "asc"
    });
    // Other Page Variables
    const [loaded, setLoaded] = useState(false);
    const [loadState, setLoadState] = useState("init");
    const [tabItem, setTabItem] = useState("add");
    const [count, setCount] = useState(0);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [storePage, setStorePage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [dContent, setDContent] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": read,
                                procedure: "getresidentstaged", reqType: "stored"}).then(data => {
                if (data){
                    setAddOrigin(data.length > 0 ? data[0] : []);
                    setEditOrigin(data.length > 1 ? data[1] : []);
                    setMoveOrigin(data.length > 2 ? data[2] : []);
                    setRemoveOrigin(data.length > 3 ? data[3]: []);
                    setLoaded(true);
                }
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_resident_groups",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": true}).then(data => {
                setGroupData(data);
            });
            setRead(false);
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(addOrigin, addHeaderFilters, addHeaderData);

        searchKeys = ["resident_first_name", "resident_last_name", "resident_nickname", "resident_phone",
            "resident_email", "area_name", ["resident_first_name", "resident_last_name"]];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, addPage, perPage);
        if (search && addPage > pRules.pageMax){
            setAddPage(pRules.pageMax);
        }else if (!search){
            setAddPage(storePage);
        }
        setAddPRules(pRules);
        setAddActive(tmpData);
    }, [search, addOrigin, addHeaderFilters]);

    useEffect(() => {
        let pRules = paginateData(addActive, addPage, perPage);
        setAddPRules(pRules);
        if (addActive.length > 0) {
            addActive.sort((a, b) => sortFunc(a, b, addSorter.sortColumn, addSorter.sortOrder));
        }
        setAddTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={addActive} checkbox={false}
                                writeAccess={true} unk={"add-"} addlEditKey={""} addlEditCheck={false}
                                actionAppearance={() => {}} tableHeaders={addHeaderData} editModal={addModal}
                                parentComponent={"Residents"} dData={dData} modalIconClass={"fe fe-check-square"}
                                modal={true} checkboxlist={[]} setCheckboxId={() => {}}
                                checkidkey={""} />);
    }, [addActive, addSorter, addPage, perPage]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["resident_group_name", "resident_description"];
        tmpData = searchFunc(search2, groupData, searchKeys);

        setGroupDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, sorter2.sortColumn, sorter2.sortOrder));
        setGroupTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                     actionAppearance={() => {}} tableHeaders={headerData2} checkboxId={"uCheckGroup"}
                                     parentComponent={"Residents"} dData={dData} checkboxlist={resGroupIdList}
                                     modal={false} editModal={() => {}} unk={"x-"}
                                     setCheckboxId={(value) => {setResGroupIdList(value)}} checkidkey={"resident_group_id"} />);
    }, [groupData, resGroupIdList, sorter2, search2]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(editOrigin, editHeaderFilters, editHeaderData);

        searchKeys = ["resident_first_name", "resident_last_name", "resident_nickname", "resident_phone",
            "resident_email", "area_name", ["resident_first_name", "resident_last_name"]];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, editPage, perPage);
        if (search && editPage > pRules.pageMax){
            setEditPage(pRules.pageMax);
        }else if (!search){
            setEditPage(storePage);
        }
        setEditPRules(pRules);
        setEditActive(tmpData);
    }, [search, editOrigin, editHeaderFilters]);

    useEffect(() => {
        let pRules = paginateData(editActive, editPage, perPage);
        setEditPRules(pRules);
        if (editActive.length > 0) {
            editActive.sort((a, b) => sortFunc(a, b, editSorter.sortColumn, editSorter.sortOrder));
        }
        setEditTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={editActive} checkbox={false}
                                writeAccess={true} unk={"edit-"} addlEditKey={""} addlEditCheck={false}
                                actionAppearance={() => {}} tableHeaders={editHeaderData} editModal={editModal}
                                parentComponent={"Residents"} dData={dData} modalIconClass={"fe fe-check-square"}
                                modal={true} checkboxlist={[]} setCheckboxId={() => {}}
                                checkidkey={""} />);
    }, [editActive, editSorter, editPage, perPage]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(moveOrigin, moveHeaderFilters, moveHeaderData);

        searchKeys = ["resident_name", "area_name"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, movePage, perPage);
        if (search && movePage > pRules.pageMax){
            setMovePage(pRules.pageMax);
        }else if (!search){
            setMovePage(storePage);
        }
        setMovePRules(pRules);
        setMoveActive(tmpData);
    }, [search, moveOrigin, moveHeaderFilters]);

    useEffect(() => {
        let pRules = paginateData(moveActive, movePage, perPage);
        setMovePRules(pRules);
        if (moveActive.length > 0) {
            moveActive.sort((a, b) => sortFunc(a, b, moveSorter.sortColumn, moveSorter.sortOrder));
        }
        setMoveTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={moveActive} checkbox={false}
                                writeAccess={true} unk={"move-"} addlEditKey={""} addlEditCheck={false}
                                actionAppearance={() => {}} tableHeaders={moveHeaderData} editModal={moveModal}
                                parentComponent={"Residents"} dData={dData} modalIconClass={"fe fe-check-square"}
                                modal={true} checkboxlist={[]} setCheckboxId={() => {}}
                                checkidkey={""} />);
    }, [moveActive, moveSorter, movePage, perPage]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(removeOrigin, removeHeaderFilters, removeHeaderData);

        searchKeys = ["resident_name", "area_name"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, removePage, perPage);
        if (search && removePage > pRules.pageMax){
            setRemovePage(pRules.pageMax);
        }else if (!search){
            setRemovePage(storePage);
        }
        setRemovePRules(pRules);
        setRemoveActive(tmpData);
    }, [search, removeOrigin, removeHeaderFilters]);

    useEffect(() => {
        let pRules = paginateData(removeActive, removePage, perPage);
        setRemovePRules(pRules);
        if (removeActive.length > 0) {
            removeActive.sort((a, b) => sortFunc(a, b, removeSorter.sortColumn, removeSorter.sortOrder));
        }
        setRemoveTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={removeActive} checkbox={false}
                                writeAccess={true} unk={"remove-"} addlEditKey={""} addlEditCheck={false}
                                actionAppearance={() => {}} tableHeaders={removeHeaderData} editModal={removeModal}
                                parentComponent={"Residents"} dData={dData} modalIconClass={"fe fe-check-square"}
                                modal={true} checkboxlist={[]} setCheckboxId={() => {}}
                                checkidkey={""} />);
    }, [removeActive, removeSorter, removePage, perPage]);

    useEffect(() => {
        if (loaded){
            let tmp;
            tmp = addOrigin.length + editOrigin.length + moveOrigin.length + removeOrigin.length;
            setDDataCampusCustom(dData, ["ehr_stg_count"], tmp);
        }
    }, [loaded]);

    function addModal(rowIndex){
        let dataIndex = parseInt(rowIndex);
        setAddStoredIndex(dataIndex);
        setResGroupIdList([]);
        document.getElementById("fName").value = addActive[dataIndex]?.resident_first_name;
        document.getElementById("lName").value = addActive[dataIndex]?.resident_last_name;
        document.getElementById("email").value = addActive[dataIndex]?.resident_email;
        document.getElementById("roomPh").value = addActive[dataIndex]?.resident_phone;
        document.getElementById("ehrid").value = addActive[dataIndex]?.ehr_resident_id;
        document.getElementById("nickname").value = addActive[dataIndex]?.resident_nickname ? addActive[dataIndex].resident_nickname : "";
        document.getElementById("carelevel").value = addActive[dataIndex]?.ehr_level_of_care_id ? addActive[dataIndex].ehr_level_of_care_id : "";
        document.getElementById("locationName").value = addActive[dataIndex]?.area_name;
        document.getElementById("locationId").value = addActive[dataIndex]?.area_id;
        document.getElementById("moveindate").value = addActive[dataIndex]?.physical_move_in_date ? convertIsoToLocalDate(addActive[dataIndex].physical_move_in_date) : ""
        setActiveModal("addmodal");
        showModal("addmodal");
    }

    function editModal(rowIndex){
        let dataIndex = parseInt(rowIndex);
        setEditStoredIndex(dataIndex);
        document.getElementById("fNameE").value = editActive[dataIndex]?.resident_first_name;
        document.getElementById("lNameE").value = editActive[dataIndex]?.resident_last_name;
        document.getElementById("emailE").value = editActive[dataIndex]?.resident_email;
        document.getElementById("roomPhE").value = editActive[dataIndex]?.resident_phone;
        document.getElementById("ehridE").value = editActive[dataIndex]?.ehr_resident_id;
        document.getElementById("nicknameE").value = editActive[dataIndex]?.resident_nickname ? editActive[dataIndex].resident_nickname : "";
        document.getElementById("carelevelE").value = editActive[dataIndex]?.ehr_level_of_care_id ? editActive[dataIndex].ehr_level_of_care_id : "";
        setActiveModal("editmodal");
        showModal("editmodal");
    }

    function moveModal(rowIndex){
        let dataIndex = parseInt(rowIndex);
        setMoveStoredIndex(dataIndex);
        setMoveResName(moveActive[dataIndex]?.resident_name)
        setMoveFromName(moveActive[dataIndex]?.old_area_name);
        setMoveToName(moveActive[dataIndex]?.area_name);
        setActiveModal("movemodal");
        showModal("movemodal")
    }

    function removeModal(rowIndex){
        let dataIndex = parseInt(rowIndex);
        setRemoveStoredIndex(dataIndex);
        setRemoveName(removeActive[dataIndex]?.resident_name);
        setRemoveArea(removeActive[dataIndex]?.old_area_name);
        setActiveModal("removemodal");
        showModal("removemodal");
    }

    function filterSubmit(){
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        dData.perPage = tmpPerPage;
        setAddPage(1);
        setEditPage(1);
        setMovePage(1);
        setRemovePage(1);
        ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), process.env.REACT_APP_ESECRET).toString());
        formSuccess("Page parameters stored to session.", "filterSubmit", "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    function formAddSubmit(){
        let payload;
        handleSubmitActions("addSubmit", "loadAddSubmit");
        payload = [{
            cloud_id: addActive[addStoredIndex].cloud_id,
            campus_id: campusId,
            resident_first_name: addActive[addStoredIndex].resident_first_name,
            resident_last_name: addActive[addStoredIndex].resident_last_name,
            resident_phone: addActive[addStoredIndex].resident_phone,
            resident_email: addActive[addStoredIndex].resident_email,
            resident_nickname: addActive[addStoredIndex].resident_nickname,
            ehr_level_of_care: addActive[addStoredIndex].ehr_level_of_care_id,
            is_area_assigned: true,
            area_id: addActive[addStoredIndex].area_id,
            resident_group_ids: resGroupIdList,
            move_in_date: addActive[addStoredIndex].physical_move_in_date,
            ehr_external_id: addActive[addStoredIndex].ehr_resident_id,
            ehr_campus_id: addActive[addStoredIndex].ehr_campus_id,
            modified_by: dData.user,
            vendor_id: dData.campusData[dData.acnt.toString()].ehr_vendor_id
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_add_task", Payload: payload,
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data && data[0] === true){
                setRead(false);
                formSuccess(`${addActive[addStoredIndex].resident_name} has been added`, "addSubmit",
                    "loadAddSubmit", "cancelAddBtn", "addForm");
                setLoaded(false);
                setCount(0);
            }
            else{
                formFail(`Error during add, error code: ${data[1]}`, "addSubmit", "loadAddSubmit");
            }
        });
    }

    function formEditSubmit(){
        let payload;
        handleSubmitActions("editSubmit", "loadEditSubmit");
        payload = [{
            cloud_id: editActive[editStoredIndex].cloud_id,
            resident_id: editActive[editStoredIndex].tmp_resident_id,
            campus_id: campusId,
            resident_first_name: editActive[editStoredIndex].resident_first_name,
            resident_last_name: editActive[editStoredIndex].resident_last_name,
            resident_nickname: editActive[addStoredIndex].resident_nickname,
            ehr_level_of_care: editActive[addStoredIndex].ehr_level_of_care_id,
            resident_phone: editActive[editStoredIndex].resident_phone,
            resident_email: editActive[editStoredIndex].resident_email,
            is_area_assigned: true,
            area_id: editActive[editStoredIndex].area_id,
            move_in_date: editActive[editStoredIndex].physical_move_in_date,
            ehr_external_id: editActive[editStoredIndex].ehr_resident_id,
            modified_by: dData.user
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_edit_task", Payload: payload,
                            OldPayload: [],
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data && data[0]){
                setRead(false);
                formSuccess(`${editActive[editStoredIndex].resident_name} updated.`, "editSubmit",
                    "loadEditSubmit", "cancelEditBtn");
                setLoaded(false);
                setCount(0);
            }
            else{
                formFail("Error during save, error code: " + data[1], "editSubmit", "loadEditSubmit");
            }
        });
    }

    function formMoveSubmit(){
        let payload, oldPayload;
        handleSubmitActions("moveConfirmSubmit", "loadMoveConfirmSubmit");
        payload = [{
            cloud_id: moveActive[moveStoredIndex].cloud_id,
            resident_id: moveActive[moveStoredIndex].tmp_resident_id,
            area_id: moveActive[moveStoredIndex].area_id,
            modified_by: dData?.user ? dData.user : 0
        }];
        oldPayload = [{
            resident_id: moveActive[moveStoredIndex].tmp_resident_id,
            area_id: moveActive[moveStoredIndex].old_area_id
        }]
        ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_move_task", Payload: payload,
                            OldPayload: oldPayload,
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data && data[0]){
                setRead(false);
                formSuccess(`Resident moved successfully to ${moveActive[moveStoredIndex].area_name}`, "moveConfirmSubmit", "loadMoveConfirmSubmit", "moveConfirmCancelBtn");
                setLoaded(false);
                setCount(0);
            }
            else{
                formFail(`Error during save, error code: ${data && data?.length > 1 ? data[1] : ""}`, "moveConfirmSubmit", "loadMoveConfirmSubmit");
            }
        });
    }

    function formRemoveSubmit(){
        let payload, msg;
        handleSubmitActions("removeConfirmSubmit", "loadRemoveConfirmSubmit");
        payload = [{
            cloud_id: removeActive[removeStoredIndex].cloud_id,
            resident_id: removeActive[removeStoredIndex].tmp_resident_id,
            move_out_date: removeActive[removeStoredIndex].physical_move_out_date,
            modified_by: dData.user
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_remove_task", Payload: payload,
                            OldPayload: [],
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0]){
                setRead(false);
                msg = `${removeActive[removeStoredIndex].resident_name} has been marked in-active`
                formSuccess(msg, "removeConfirmSubmit", "loadRemoveConfirmSubmit",
                    "removeConfirmCancelBtn");
                setLoaded(false);
                setCount(0);
            }
            else{
                msg = `Error during delete, error code: ${data[1]}`;
                formFail(msg, "removeConfirmSubmit", "loadRemoveConfirmSubmit");
            }
        });
    }

    function formRejectSubmit(){
        let payload, msg, cloudId, resName, rejectText = "";
        handleSubmitActions("rejectConfirmSubmit", "loadRejectConfirmSubmit");
        if (activeModal === "addmodal"){
            rejectText = "Move-in";
            cloudId = addActive[addStoredIndex].cloud_id;
            resName = addActive[addStoredIndex].resident_name;
        }else if (activeModal === "editmodal"){
            rejectText = "Update";
            cloudId = editActive[editStoredIndex].cloud_id;
            resName = editActive[editStoredIndex].resident_name;
        }else if (activeModal === "movemodal"){
            rejectText = "Relocate";
            cloudId = moveActive[moveStoredIndex].cloud_id;
            resName = moveActive[moveStoredIndex].resident_name;
        }else{
            rejectText = "Move-out";
            cloudId = removeActive[removeStoredIndex].cloud_id;
            resName = removeActive[removeStoredIndex].resident_name;
        }
        payload = [{
            cloud_id: cloudId,
            modified_by: dData.user
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_reject_task", Payload: payload,
                            OldPayload: [],
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0]){
                setRead(false);
                msg = `${rejectText} task for ${resName} has been removed.`
                formSuccess(msg, "rejectConfirmSubmit", "loadRejectConfirmSubmit",
                    "rejectConfirmClose");
                setLoaded(false);
                setCount(0);
            }
            else{
                msg = `Error during rejection, error code: ${data[1]}`;
                formFail(msg, "rejectConfirmSubmit", "loadRejectConfirmSubmit");
            }
        });
    }

    const addTableHeaders = <TableHeaders checkbox={false} headerData={addHeaderData} checkAll={() => {}}
                                          writeAccess={true} sortOrder={addSorter.sortOrder} modal_name={"Add"}
                                          sortColumn={addSorter.sortColumn} sorter={addSorter} originData={addOrigin} headerFiltersOn={true}
                                          setSorter={setAddSorter} modal={true} checkboxlist={[]}
                                          actionAppearance={() => {}} headerFilters={addHeaderFilters} setHeaderFilters={setAddHeaderFilters} />

    const editTableHeaders = <TableHeaders checkbox={false} headerData={editHeaderData} checkAll={() => {}}
                                          writeAccess={true} sortOrder={editSorter.sortOrder} modal_name={"Edit"}
                                          sortColumn={editSorter.sortColumn} sorter={editSorter} originData={editOrigin} headerFiltersOn={true}
                                          setSorter={setEditSorter} modal={true} checkboxlist={[]}
                                          actionAppearance={() => {}} headerFilters={editHeaderFilters} setHeaderFilters={setEditHeaderFilters} />

    const moveTableHeaders = <TableHeaders checkbox={false} headerData={moveHeaderData} checkAll={() => {}}
                                          writeAccess={true} sortOrder={moveSorter.sortOrder} modal_name={"Move"}
                                          sortColumn={moveSorter.sortColumn} sorter={moveSorter} originData={moveOrigin} headerFiltersOn={true}
                                          setSorter={setMoveSorter} modal={true} checkboxlist={[]}
                                          actionAppearance={() => {}} headerFilters={moveHeaderFilters} setHeaderFilters={setMoveHeaderFilters} />

    const removeTableHeaders = <TableHeaders checkbox={false} headerData={removeHeaderData} checkAll={() => {}}
                                          writeAccess={true} sortOrder={removeSorter.sortOrder} modal_name={"Remove"}
                                          sortColumn={removeSorter.sortColumn} sorter={removeSorter} originData={removeOrigin} headerFiltersOn={true}
                                          setSorter={setRemoveSorter} modal={true} checkboxlist={[]}
                                          actionAppearance={() => {}} headerFilters={removeHeaderFilters} setHeaderFilters={setRemoveHeaderFilters} />

    const groupAddTableHead = <TableHeaders checkbox={true} headerData={headerData2} checkboxlist={resGroupIdList}
                                         checkAll={() => checkAll(0, groupDataCnt ? groupDataCnt : 0, resGroupIdList, setResGroupIdList, "uCheckHead3", "uCheckGroup")}
                                         writeAccess={true} sortOrder={sorter2.sortOrder} checkboxHeaderId={"uCheckHead3"}
                                         sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2}
                                         actionAppearance={() => {}} />

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div>
                <div className={"form-outline d-inline-flex align-bottom ms-2"}>
                    <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                         onKeyUp={(e) => setSearch(e.target.value)} />
                    <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"} style={{height: "42px"}}
                            icon={true} iconClass={"fe fe-search"}/>
                </div>
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)}
                            pageAction={(e) => {
                                if (!dData.campusData[e.target.value]?.ehr_active){
                                    window.location.href = "/";
                                }else{
                                    setLoaded(false);
                                }
                            }}/>
        </div>
    );

    if (tabItem === "update"){
        paginatePage = editPage;
        paginateSetPage = setEditPage;
        paginateBegin = editPRules.beginDot;
        paginateEnd = editPRules.endDot;
        paginatePMin = editPRules.pageMin;
        paginatePMax = editPRules.pageMax;
        paginateMax = editPRules.max;
    }else if (tabItem === "move"){
        paginatePage = movePage;
        paginateSetPage = setMovePage;
        paginateBegin = movePRules.beginDot;
        paginateEnd = movePRules.endDot;
        paginatePMin = movePRules.pageMin;
        paginatePMax = movePRules.pageMax;
        paginateMax = movePRules.max;
    }else if (tabItem === "remove"){
        paginatePage = removePage;
        paginateSetPage = setRemovePage;
        paginateBegin = removePRules.beginDot;
        paginateEnd = removePRules.endDot;
        paginatePMin = removePRules.pageMin;
        paginatePMax = removePRules.pageMax;
        paginateMax = removePRules.max;
    }else{
        paginatePage = addPage;
        paginateSetPage = setAddPage;
        paginateBegin = addPRules.beginDot;
        paginateEnd = addPRules.endDot;
        paginatePMin = addPRules.pageMin;
        paginatePMax = addPRules.pageMax;
        paginateMax = addPRules.max;
    }

    const footer = (
        <div>
            <Pagination>
                <PaginationItems setPage={paginateSetPage} page={paginatePage} beginDot={paginateBegin}
                                 endDot={paginateEnd} pageMin={paginatePMin} pageMax={paginatePMax}
                                 max={paginateMax}/>
            </Pagination>
            <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
        </div>
    );

    return (
        <>
            <Navigation/>
            <div className={"main-content"}>
                <Header preTitle={"Tasks"} Title={"EHR"} content={headerContent}/>
                <div className={"container-fluid"}>
                    <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                        <li className={"nav-item"}>
                            <button type={"button"} className={tabItem === "add" ? "nav-link active" : "nav-link"}
                                    onClick={() => setTabItem("add")}>
                                Move-in Resident
                                <span className={"position-relative translate-middle badge rounded-pill bg-danger"}
                                      style={{left: "15px"}}>{addOrigin?.length > 0 ? addOrigin.length : ""}</span>
                            </button>
                        </li>
                        <li className={"nav-item"}>
                            <button type={"button"} className={tabItem === "move" ? "nav-link active" : "nav-link"}
                                    onClick={() => setTabItem("move")}>
                                Relocate Resident
                                <span className={"position-relative translate-middle badge rounded-pill bg-danger"}
                                      style={{left: "15px"}}>{moveOrigin?.length > 0 ? moveOrigin.length : ""}</span>
                            </button>
                        </li>
                        <li className={"nav-item"}>
                            <button type={"button"} className={tabItem === "remove" ? "nav-link active" : "nav-link"}
                                    onClick={() => setTabItem("remove")}>
                                Move-out Resident
                                <span className={"position-relative translate-middle badge rounded-pill bg-danger"}
                                      style={{left: "15px"}}>{removeOrigin?.length > 0 ? removeOrigin.length : ""}</span>
                            </button>
                        </li>
                        <li className={"nav-item"}>
                            <button type={"button"} className={tabItem === "update" ? "nav-link active" : "nav-link"}
                                    onClick={() => setTabItem("update")}>
                                Update Resident Info
                                <span className={"position-relative translate-middle badge rounded-pill bg-danger"}
                                      style={{left: "15px"}}>{editOrigin?.length > 0 ? editOrigin.length : ""}</span>
                            </button>
                        </li>
                    </ul>
                    <div>
                        <div className={tabItem === "add" ? "d-block" : "d-none"}>
                            {addActive.length > 0
                                ? <table className={"table table-sm table-white table-hover"}>
                                    <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {addTableHeaders}
                                    </thead>
                                    <tbody id={"tBody"}>
                                    {addTableRows}
                                        </tbody>
                                    </table>
                                :   <h3 className={"mt-5"}>No move-in tasks to approve</h3>

                            }
                        </div>
                        <div className={tabItem === "update" ? "d-block" : "d-none"}>
                            {editActive.length > 0
                                ?   <table className={"table table-sm table-white table-hover"}>
                                        <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                        {editTableHeaders}
                                        </thead>
                                        <tbody id={"tBody"}>
                                        {editTableRows}
                                        </tbody>
                                    </table>
                                :   <h3 className={"mt-5"}>No update tasks to approve</h3>
                            }

                        </div>
                        <div className={tabItem === "move" ? "d-block" : "d-none"}>
                            {moveActive.length > 0
                                ?   <table className={"table table-sm table-white table-hover"}>
                                        <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                        {moveTableHeaders}
                                        </thead>
                                        <tbody id={"tBody"}>
                                        {moveTableRows}
                                        </tbody>
                                    </table>
                                :   <h3 className={"mt-5"}>No relocating tasks to approve</h3>
                            }
                        </div>
                        <div className={tabItem === "remove" ? "d-block" : "d-none"}>
                            {removeActive.length > 0
                                ?   <table className={"table table-sm table-white table-hover"}>
                                        <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                        {removeTableHeaders}
                                        </thead>
                                        <tbody id={"tBody"}>
                                        {removeTableRows}
                                        </tbody>
                                    </table>
                                :   <h3 className={"mt-5"}>No move-out tasks to approve</h3>
                            }
                        </div>
                    </div>
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                <Footer center={footer}/>
            </div>
            <div className={"modal fade"} id={"addmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Approve Resident Add</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"addForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <h3 className={"text-danger mb-4 text-center"}>ATTENTION! Must still attach pendant
                                    devices after approval!</h3>
                                <input type={"hidden"} id={"locationId"}/>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"locationName"}
                                           readOnly={true}/>
                                    <label htmlFor={"locationName"}>Area Name</label>
                                </div>
                                <div className={"row"}>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"fName"} readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"fName"}>First Name</label>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"lName"} readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"lName"}>Last Name</label>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"nickname"} readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"nickname"}>Nickname</label>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"carelevel"} readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"carelevel"}>Care Level</label>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"roomPh"} readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"roomPh"}>Room Phone #</label>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"email"} readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"email"}>Email Address</label>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"moveindate"}
                                               readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"moveindate"}>Move-in Date</label>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"ehrid"} readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"ehrid"}>EHR ID</label>
                                    </div>
                                </div>
                                <hr/>
                                <div className={"mt-1"}>
                                    <h3>Groups</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)}/>
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}
                                                id={"search-btn-2"}/>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                            {groupAddTableHead}
                                            </thead>
                                            <tbody>
                                            {groupTableRows}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer justify-content-between"}>
                                <div>
                                    <button type={"button"} className={"btn btn-outline-danger"}
                                            onClick={() => swapModal("cancelAddBtn", "rejectmodal")}>Reject
                                    </button>
                                </div>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary me-3"} id={"cancelAddBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none"} disabled={true} spinner={true}
                                            text={"Loading"} id={"loadAddSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary"} onClick={() => formAddSubmit()}
                                            id={"addSubmit"}>Approve
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"editmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticEditBackdropLabel"} aria-hidden={"true"}
                 style={{overflowY: "auto"}}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticEditBackdropLabel"}>Approve Resident Info</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"editForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"row"}>
                                    <input type={"hidden"} id={"resUnqIdE"}/>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"fNameE"}
                                               readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"fNameE"}>First Name</label>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"lNameE"}
                                               readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"lNameE"}>Last Name</label>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <input type={"hidden"} id={"resUnqIdE"}/>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"nicknameE"}
                                               readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"nicknameE"}>Nickname</label>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"carelevelE"}
                                               readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"carelevelE"}>Care Level</label>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"roomPhE"}
                                               readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"roomPhE"}>Room Phone #</label>
                                    </div>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"emailE"}
                                               readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"emailE"}>Email</label>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"form-floating col-6 mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"ehridE"}
                                               readOnly={true}/>
                                        <label className={"ms-3"} htmlFor={"ehridE"}>EHR ID</label>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer justify-content-between"}>
                                <div>
                                    <button type={"button"} className={"btn btn-outline-danger"}
                                            onClick={() => swapModal("cancelEditBtn", "rejectmodal")}>Reject
                                    </button>
                                </div>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelEditBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadEditSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"}
                                            onClick={() => formEditSubmit()} id={"editSubmit"}>Approve
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"movemodal"} data-bs-backdrop={"static"}
                 data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Confirm Relocation</h2>
                            <button type={"button"} className={"btn-close"} id={"moveConfirmClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <p>Are you sure you wish to move <span className={"fw-bold"}>{moveResName}</span> from <span
                                className={"fw-bold"}>{moveFromName ? moveFromName : "No Room"}</span> to <span className={"fw-bold"}>{moveToName}</span></p>
                        </div>
                        <div className={"modal-footer justify-content-between"}>
                            <div>
                                <button type={"button"} className={"btn btn-outline-danger"}
                                        onClick={() => swapModal("moveConfirmCancelBtn", "rejectmodal")}>Reject
                                </button>
                            </div>
                            <div>
                                <button type={"button"} className={"btn btn-secondary"} style={{width: "75px"}}
                                    id={"moveConfirmCancelBtn"} data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true}
                                        text={"Loading"} id={"loadMoveConfirmSubmit"}/>
                                <button type={"button"} className={"btn btn-primary ms-3"} id={"moveConfirmSubmit"}
                                        onClick={() => formMoveSubmit()}>Approve
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"removemodal"} data-bs-backdrop={"static"}
                 data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Confirm Move-out</h2>
                            <button type={"button"} className={"btn-close"} id={"removeConfirmClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <p>Are you sure you wish to confirm moving out <span className={"fw-bold"}>{removeName}</span> from {removeArea}?</p>
                        </div>
                        <div className={"modal-footer justify-content-between"}>
                            <div>
                                <button type={"button"} className={"btn btn-outline-danger"}
                                        onClick={() => swapModal("removeConfirmCancelBtn", "rejectmodal")}>Reject
                                </button>
                            </div>
                            <div>
                                <button type={"button"} className={"btn btn-secondary"} style={{width: "75px"}}
                                        id={"removeConfirmCancelBtn"} data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true}
                                        text={"Loading"} id={"loadRemoveConfirmSubmit"}/>
                                <button type={"button"} className={"btn btn-primary ms-3"} id={"removeConfirmSubmit"}
                                        onClick={() => formRemoveSubmit()}>Approve
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"rejectmodal"} data-bs-backdrop={"static"}
                 data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Confirm Task Rejection</h2>
                            <button type={"button"} className={"btn-close"} id={"rejectConfirmClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <p>Are you sure you wish to reject this task? New changes within {dData.campusData[dData.acnt.toString()].ehr_vendor_name} will be necessary to recreate the task.</p>
                        </div>
                        <div className={"modal-footer justify-content-between"}>
                            <div>

                            </div>
                            <div>
                                <button type={"button"} className={"btn btn-secondary"} style={{width: "75px"}}
                                        id={"rejectConfirmCancelBtn"} data-bs-dismiss={"modal"}
                                        onClick={() => showModal(activeModal)}>
                                    No
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true}
                                        text={"Loading"} id={"loadRejectConfirmSubmit"}/>
                                <button type={"button"} className={"btn btn-primary ms-3"} id={"rejectConfirmSubmit"}
                                        onClick={() => formRejectSubmit()}>
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage}
                          setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)} setPage={(sudocode) => {
                setAddPage(sudocode);
                setEditPage(sudocode);
                setMovePage(sudocode);
                setRemovePage(sudocode);
            }}/>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"uContent"}/>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default TasksEhr;